import React from 'react'

export default () => (
  <svg width="26" height="35" viewBox="0 0 26 35" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M24.8124 17.0167L1.64613 1.03999C1.40089 0.87144 1.08295 0.853865 0.820931 0.990466C0.558115 1.12866 0.393555 1.40027 0.393555 1.69744V33.6508C0.393555 33.948 0.558115 34.2204 0.820931 34.3586C0.937561 34.4193 1.06538 34.4497 1.19239 34.4497C1.35136 34.4497 1.50953 34.4017 1.64613 34.3083L24.8124 18.3316C25.0288 18.1822 25.1575 17.937 25.1575 17.6741C25.1575 17.4113 25.028 17.1661 24.8124 17.0167Z" fill="white"/>
	</svg>
)